import { useContext } from 'react';
import MainLayout from '../../../../Layout/MainLayout';
import { usePlanAccess } from '../../../../components/gating/PlanGate';
import RoleManagementContext from '../../../../context/roleManagement/RoleManagementContext';
import AddUserHeader from '../Header/AddUserHeader';
import AddUserForm from './sections/AddUserForm';
import AccessRestricted from '../Shared/AccessRestricted';

const AddUserPage = () => {
  const { isLocked: isRolesLocked } = usePlanAccess('enterprise');
  const { currentUserRole, isRestricted, addMember } = useContext(RoleManagementContext);
  const isSubadmin = currentUserRole === 'subadmin';

  return (
    <MainLayout activeTab="role-management">
      <div className="p-3 md:p-6 max-w-4xl mx-auto animate-page-entry font-sans">
        <AddUserHeader />

        {isRestricted ? (
          <AccessRestricted
            currentUserRole={currentUserRole}
            message="You do not have permission to add team members."
          />
        ) : (
          <AddUserForm
            isRolesLocked={isRolesLocked}
            isSubadmin={isSubadmin}
            onAddMember={addMember}
          />
        )}
      </div>
    </MainLayout>
  );
};

export default AddUserPage;
